// Constants for different requests for current reducer
export default {
  siteInfoAddress: 'SITE_INFO_ADDRESS',
};
